<template>
  <v-navigation-drawer app v-model="drawer">
    <v-toolbar flat dark>
      <v-list>
        <v-list-tile>
          <v-list-tile-title class="title">
            Colina del Manzano
          </v-list-tile-title>
          <v-spacer></v-spacer>
          <v-icon @click="closeDrawer">$vuetify.icons.times</v-icon>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-list>
      <v-list-tile>
        <v-list-tile-avatar color="light-green darken-1">
          <v-icon>$vuetify.icons.user</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>
            {{this.$store.state.sessionData.role}}
          </v-list-tile-title>
        </v-list-tile-content>
        <v-list-tile-action>
          <v-icon @click="signOut">$vuetify.icons.sign-out-alt</v-icon>
        </v-list-tile-action>
      </v-list-tile>
      <v-divider></v-divider>
      <v-subheader>
        Menu
      </v-subheader>
      <v-list-tile @click="$router.push('/')">
        <v-list-tile-action class="mr-3">
          <v-icon>$vuetify.icons.home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            Home
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="$router.push('/reservas')">
        <v-list-tile-action class="mr-3">
          <v-icon>$vuetify.icons.list-ul</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            Reservas
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-list-tile @click="$router.push('/agenda')">
        <v-list-tile-action class="mr-3">
          <v-icon>$vuetify.icons.calendar-alt</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>
            Agenda
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-subheader>
        Cotización del dólar
      </v-subheader>
      <v-list-tile>
        <v-icon class="mr-3">$vuetify.icons.dollar-sign</v-icon>
        <v-list-tile-content>
          <v-list-tile-title v-if="currencyLoaded">
            {{currency | currencyVal}}, {{currencyDate}}
          </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>
<script>
import mixins from '@/mixins/mixins';
import filters from '@/mixins/filters';
// import axios from 'axios';

export default {
  computed: {
    drawer: {
      get() {
        return this.$store.state.drawer;
      },
      set(newVal) {
        return newVal;
      },
    },
    currency() {
      return this.$store.state.currency;
    },
    currencyLoaded() {
      return this.$store.state.currencyLoaded;
    },
    currencyDate() {
      return this.$store.state.currencyDate;
    },
  },
  methods: {
    signOut() {
      this.$store.dispatch('goBackToLogin', 'signOut');
      this.closeDrawer();
    //   window.localStorage.removeItem('api_token')
    //   window.localStorage.removeItem('role')
    //   axios.post('http://sd-863073-h00104.ferozo.net/api/logout')
    //   this.$router.push('/');
    },
  },
  data() {
    return {
      dollar: null,
    };
  },
  created() {
    this.$store.dispatch('getCurrency');
  },
  mixins: [
    mixins,
    filters,
  ],
};
</script>
